import { useDispatch } from 'react-redux';
import CloseButtonModal from '../../../../ui/close-button-modal';
import { setSubAmendmentModal } from '../../../../../features/actuarial/request-amendment/request-amendment.slice';
import { useProposalData } from '../../../../../hooks/populate-data/use-proposal-data';
import { useProposeData } from '../../../../../hooks/populate-data/use-propose-data';
import ProposeProposalView from '../../propose-proposal-view';
import { useEffect } from 'react';
import LoadingState from '../../../../ui/loadibg-state';
import ErrorState from '../../../../ui/error-state';

const ProposeAndCurrentData = () => {

    const dispatch = useDispatch();
    const {
        proposal: currentProposal,
        isLoadingProposal,
        isErrorProposal,
        proposalErrorMessage,
        repopulateAll,
    } = useProposalData();

    const {
        proposal: proposedPatch,
        isLoadingGetAmendmentHistoryLogs,
        isErrorGetAmendmentHistoryLogs,
        errorMessageGetAmendmentHistoryLogs,
        selectedAmendment,
        repopulateProposeAll,
    } = useProposeData();

    const isLoading = isLoadingProposal || isLoadingGetAmendmentHistoryLogs
    const isError = isErrorProposal || isErrorGetAmendmentHistoryLogs;

    const errorMessage = proposalErrorMessage || errorMessageGetAmendmentHistoryLogs || 'Unable to load proposal comparison data.';
    
    useEffect(() => {
        if (!currentProposal?.application_id) {
            return;
        }

        repopulateAll();
    }, [
        currentProposal?.application_id,
        repopulateAll,
    ]);

    useEffect(() => {
        if (!proposedPatch || !selectedAmendment?.amendment_id) {
            return;
        }

        repopulateProposeAll();
    }, [
        proposedPatch,
        selectedAmendment?.amendment_id,
        repopulateProposeAll,
    ]);


    return (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-start z-50 p-4">
            <div className="h-[96dvh] w-full bg-[#f5f9fd] rounded overflow-hidden shadow my-auto flex flex-col sm:h-[90dvh] sm:max-w-[95vw] lg:max-w-[700px] xl:max-w-[1000px] 2xl:max-w-[1100px]">
                <div className="flex shrink-0 items-center justify-between gap-3 border-b border-slate-200 bg-white px-3 py-2.5 sm:px-4">
                    <div className="min-w-0">
                        <p className="truncate text-xs font-semibold text-slate-800">
                            Amendment Review
                        </p>
                        <p className="mt-0.5 text-[10px] text-slate-400">
                            Compare the current proposal with the changes submitted by CFE.
                        </p>
                    </div>
                    <CloseButtonModal handleClose={() => dispatch(setSubAmendmentModal(null))} />
                </div>
                {isLoading ? (
                    <LoadingState />
                ) : isError ? (
                    <ErrorState description={errorMessage} />
                ) : (
                    <div className="min-h-0 flex-1 overflow-y-auto px-3 py-3 sm:px-5 sm:py-4 lg:px-6">
                        <div className="space-y-3">
                            <div className='grid grid-cols-1'>
                                <ProposeProposalView />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProposeAndCurrentData;